import i18n from "@/i18n";
import { SettingsVue } from "fs-pb-vue2/vueModels/settings/SettingsVue";
import { container } from "@/inversify.config";
import IAlertService from "fs-pb-vue2/services/alert/IAlertService";
import { DiTokens } from "fs-pb-vue2/services/diTokens";

export class SettingsVueGB extends SettingsVue {

  shortCodeOn: boolean = false;

  shortCodeOnAction() {
    if (!this.shortCodeOn) {
      window.localStorage.setItem('loginWithoutPasswordOn', undefined);
    } else {
      this.dialogContent = new Object({
        vueName: "ShortCodeSetModal",
      });
      this.dialogLoginSettings = true;
    }
  }

  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  get deviceGUID(): string {
    return window.localStorage.getItem(this.personStore.personInfo.Data.Login);
  }


  /**
 * Признак входа без логина/пароля
 */
  // get loginWithoutPasswordOn(): boolean {
  //   return window.localStorage.getItem('loginWithoutPasswordOn') === "1"
  //     && !!window.localStorage.getItem('deviceId')
  //     && !!window.localStorage.getItem('loginValue');
  // }


  /**
   * Признак мобильного браузера
   */
  get isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent;
    const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
    return mobileRegExp.test(userAgent);
  }

  /**Закрытие формыы */
  async destroyForm(): Promise<void> {
    this.$emit("hideSelf");
  }

  async callAction(action: () => Promise<void>) {
    await action();
  }

  /** контент диалогового окна */
  dialogContent: any = {};

  dialogTransfer: boolean = false;

  dialogLoginSettings: boolean = false;

  get actionsLogin(): Array<any> {
    const actionsLogin: Array<any> = [];

    if (this.isMobileBrowser && this.shortCodeOn)
      actionsLogin.push({
        /** Смена пароля */
        text: "Смена короткого кода",
        iconClass: "short-code-settings-icon",
        action: () => {
          this.dialogContent = new Object({
            vueName: "ShortCodeSetModal",
          });
          this.dialogLoginSettings = true;
        }
      });

    actionsLogin.push({
      /** Смена пароля */
      text: i18n.t("main.settings.changePassword"),
      iconClass: "login-settings-icon",
      action: () => {
        this.dialogContent = new Object({
          vueName: "PasswordEditModal",
        });
        this.dialogLoginSettings = true;
      }
    });

    // if (!this.deviceGUID && navigator && navigator.credentials) {
    //   actionsLogin.push({
    //     /** Авторизация без пароля */
    //     text: i18n.t("main.settings.authWithoutPass"),
    //     iconClass: "login-settings-icon",
    //     action: () => {
    //       this.dialogContent = new Object({
    //         vueName: "AuthWithoutPassModal",
    //       });
    //       this.dialogLoginSettings = true;
    //     }
    //   });
    // }

    return actionsLogin;
  }

  get actions(): Array<any> {
    const actions: Array<any> = [];
    if (this.apiData.OperationCodeOfSetSbpDefaultBank) {
      actions.push({
        /** Установка банка в сбп по умолчанию */
        text: i18n.t("main.settings.sbpDefault"),
        iconClass: "sbp-icon",
        action: () => {
          this.dialogContent = new Object({
            vueName: "SbpDefaultModal",
          });
          this.dialogTransfer = true;
        }
      });
    }
    if (this.apiData &&
      this.apiData.OperationCodeOfSetSbpMe2MeAcceptedBanks) {
      actions.push({
        /** Запрос на перевод из других банков */
        text: i18n.t("main.settings.sbpBanks"),
        iconClass: "sbp-icon",
        action: () => {
          this.dialogContent = new Object({
            vueName: "BankSelectModal",
          });
          this.dialogTransfer = true;
        }
      });
    }
    if (this.apiData.OperationCodeOfSetSbpEnable) {
      actions.push({
        /** Разрешения сбп */
        text: i18n.t("main.settings.sbpEnable"),
        iconClass: "sbp-icon",
        action: () => {
          this.dialogContent = new Object({
            vueName: "SbpEnableModal",
          });
          this.dialogTransfer = true;
        }
      });
    }
    // if (this.apiData.OperationCodeOfSetSbpDefaultBank) {
    //   actions.push({
    //     /** Удаление банка в сбп по умолчанию */
    //     text: i18n.t("main.settings.sbpDeleteDef"),
    //     iconClass: "sbp-icon",
    //     action: () => {
    //       this.dialogContent = new Object({
    //         vueName: "SbpDeleteDefaultModal",
    //       });
    //       this.dialogTransfer = true;
    //     }
    //   });
    // }

    // actions.push({
    //   /**Действие оплаты со счета */
    //   text: i18n.t("main.settings.editAlias"),
    //   iconClass: "edit-login-icon",
    //   action: () => {
    //     this.openDialog(this.operationsList.aliasEdit);
    //   }
    // });
    // actions.push({
    //   /**Действие оплаты со счета */
    //   text: i18n.t("main.settings.logout"),
    //   iconClass: "logout-icon",
    //   action: async () => {
    //     await this.logout();
    //   }
    // });
    return actions;
  }

  setShowHiddenItems() {
    this.configStore.setItemsVisibility(this.showHiddenItems);
  }

  setShowClosedItems() {
    this.configStore.setClosedItemsVisibility(this.showClosedItems);
  }
}
